import React, { Component } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import noop from 'lodash/noop';
import Button from 'yoda-core-components/lib/components/Button/Button';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import SflError from 'yoda-core-components/lib/assets/svg/SflError.svg';
import IconClose from 'yoda-core-components/lib/assets/svg/IconClose.svg';
import Success from 'yoda-core-components/lib/assets/svg/Success.svg';
import Loader from 'yoda-core-components/lib/components/Loader/Loader';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import CheckBox from 'yoda-core-components/lib/components/CheckBox/CheckBox';
import orderActions from '../../actions/OrderAction';
import { addParams } from '../../helpers/Utils/query';
import { selectMyAlertsWrapper } from '../../selectors/PdpNameSpaceSelector';
import {
    selectDeviceName,
    selectFeatureFlags,
    selectPreferences,
} from '../../selectors/ContextSelector';
import { signupForAlerts, clearData, myAlertsLoader } from '../../actions/MyAlertsAction';
import { getFilteredSkuId } from '../../selectors/ProductOptionsSelector';
import * as styles from './MyAlertsSignup.css';
import { getMyALertsEmailId, MY_ALERTS_EMAIL } from '../../helpers/myAlerts/getMyALertsEmailId';

const cx = classNames.bind(styles);
const ENTER = 'Enter';
const OPTINTYPE = 'EMAIL';

export class MyAlertsSignup extends Component {
    static defaultProps = {
        actions: {},
        myAlerts: {
            isLoader: false,
        },
        deviceName: 'desktop',
        featureFlags: {},
        skuId: '',
        miniPDP: false,
        onTooltipClose: noop,
        pdpSignUpErrorMsg: false,
        optinOrigin: 'OPOP',
        fromMiniPDP: false,
    };

    static propTypes = {
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        myAlerts: PropTypes.object,
        featureFlags: PropTypes.object,
        deviceName: PropTypes.string,
        skuId: PropTypes.string,
        miniPDP: PropTypes.bool,
        onTooltipClose: PropTypes.func,
        pdpSignUpErrorMsg: PropTypes.bool,
        optinOrigin: PropTypes.string,
        fromMiniPDP: PropTypes.bool,
    };

    /* istanbul ignore next */
    constructor(props) {
        super(props);
        this.notifyMe = this.notifyMe.bind(this);
        this.onNotifyMeFocus = this.onNotifyMeFocus.bind(this);
        this.onNotifyKeypress = this.onNotifyKeypress.bind(this);
        this.closeToolTip = this.closeToolTip.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.tooltipRef = React.createRef();
    }

    state = {
        invalidEmail: false,
        emailId: '',
        optinChecked: false,
    };

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillMount() {
        const {
            featureFlags: { persistMyAlertEmail = true },
        } = this.props;

        if (persistMyAlertEmail) {
            const myAlertEmailId = getMyALertsEmailId();
            myAlertEmailId && this.setState({ emailId: myAlertEmailId });
        }
        document.removeEventListener('click', this.handleClickOutside);
    }

    onInputChange(e) {
        this.setState({ emailId: e.target.value });
    }

    onNotifyMeFocus() {
        this.setState({ invalidEmail: false });
    }

    onNotifyKeypress(e) {
        /* istanbul ignore next */
        if (e.key === ENTER) {
            this.notifyMe();
        } else if (this.state.invalidEmail) {
            this.setState({ invalidEmail: false });
        }
    }

    /* istanbul ignore next */
    onChangeOptinCheckbox = (e) => {
        this.setState({
            optinChecked: e.event.target.checked,
        });
    };

    notifyMe() {
        const { skuId, deviceName, featureFlags } = this.props;
        const { emailId } = this.state;
        const emailRegX = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        const isEmailId = emailRegX.test(emailId);
        // never send empty referer
        let referer = get(document, 'referrer', document.location.href);
        /* istanbul ignore next */
        referer = isEmpty(referer) ? document.location.href : referer;

        /* istanbul ignore next */
        if (isEmailId) {
            const link = addParams(window.location.href, { selectedSKUId: skuId });
            const source = {
                referer,
                name: deviceName,
                user_agent: get(navigator, 'userAgent', null),
            };
            this.props.actions.myAlertsLoader({
                isLoader: true,
                sourceMiniPDP: this.props.fromMiniPDP,
            });
            this.props.actions.signupForAlerts(
                emailId,
                skuId,
                link,
                source,
                featureFlags,
                this.props.fromMiniPDP
            );
            LocalStorage.setData(MY_ALERTS_EMAIL, emailId);

            if (this.state.optinChecked) {
                this.props.actions.optin({
                    type: OPTINTYPE,
                    value: emailId,
                    'x-optin-origin': this.props.optinOrigin,
                    from: 'pdp',
                });
            }
        } else {
            this.setState({ invalidEmail: true });
        }
    }

    closeToolTip() {
        this.props.onTooltipClose();
    }

    handleClickOutside = (event) => {
        if (this.tooltipRef.current && !this.tooltipRef.current.contains(event.target)) {
            this.props.onTooltipClose();
            document.removeEventListener('click', this.handleClickOutside);
        }
    };

    render() {
        const { invalidEmail, emailId } = this.state;
        const { myAlerts, miniPDP, pdpSignUpErrorMsg, featureFlags } = this.props;
        const loaderWrapper = {
            wrapper: 'alertsSignupSlideLoader',
        };
        let successBlock = null;

        if (!myAlerts.isSuccess) {
            successBlock = (
                <div
                    className={cx('notifyMeBtnWrapper', { centerNotifyMeBtn: !miniPDP })}
                    ref={this.tooltipRef}
                >
                    <Button
                        size="Md"
                        buttonType="Tertiary"
                        automationId="myalertBtn"
                        className={cx('notifyMeBtn')}
                        onClick={this.notifyMe}
                    >
                        Submit
                    </Button>
                </div>
            );
        } else {
            successBlock = (
                <div className={cx('successIcon')}>
                    <Icon
                        type="button"
                        iconType="svg"
                        width="48px"
                        height="48px"
                        viewBox="0 0 25 25"
                    >
                        <Success />
                    </Icon>
                </div>
            );
        }

        return (
            <div className={cx('myAlertsContainer')} ref={this.tooltipRef}>
                <h2 className={cx('myAlertsHead', 'col11', 'noPad')}>Sign Up for In Stock Alert</h2>
                <div className={cx('myAlertsHeading')}>
                    {!miniPDP && (
                        <Button
                            buttonType="Link"
                            className={cx('col1', 'myAlertsClose')}
                            onClick={this.closeToolTip}
                        >
                            <Icon
                                type="button"
                                iconType="svg"
                                width="24px"
                                height="24px"
                                viewBox="0 0 25 25"
                                automationId="myalert-close"
                            >
                                <IconClose />
                            </Icon>
                        </Button>
                    )}
                </div>
                <div>
                    {myAlerts.isFailuire && (
                        <div
                            className={cx('invalidErrorBg', { pdpSignUpError: pdpSignUpErrorMsg })}
                        >
                            <div className={cx('errorIcon')}>
                                <Icon
                                    type="button"
                                    iconType="svg"
                                    width="40px"
                                    height="40px"
                                    viewBox="0 0 25 25"
                                >
                                    <SflError />
                                </Icon>
                            </div>
                            <p className={cx('invalidApiError')}>
                                There was a problem signing up your email. Please try again.
                            </p>
                        </div>
                    )}
                    <div className={cx('getInStockInput')}>
                        <input
                            className={cx({ invalidError: invalidEmail })}
                            onFocus={this.onNotifyMeFocus}
                            onKeyPress={this.onNotifyKeypress}
                            onChange={this.onInputChange}
                            value={emailId}
                            id="getInStockEmail"
                            type="email"
                            placeholder=" "
                        />
                        <label
                            htmlFor="getInStockEmail"
                            className={cx({ invalidError: invalidEmail })}
                        >
                            Enter your email
                        </label>
                    </div>
                    {invalidEmail ? (
                        <p className={cx('invalidErrorText')}>Please enter a valid email address</p>
                    ) : (
                        ''
                    )}
                    {featureFlags.myAlertsOptin && (
                        <CheckBox
                            labelContainerClass={cx('pdpOptinCheckbox')}
                            labelClass={cx('pdpOptinLabel')}
                            config={{ id: 'pdp-optin-checkbox' }}
                            onChange={this.onChangeOptinCheckbox}
                            label="Also send me special JCP offers"
                            enableFastClick
                        />
                    )}
                    {
                        /* istanbul ignore next */
                        myAlerts.isLoader ? (
                            <div className={cx('loaderBlock')}>
                                <Loader
                                    loaderClass={cx('loaderPosition', {
                                        alertsSignupSlide: miniPDP,
                                    })}
                                    themeConfig={miniPDP && loaderWrapper}
                                />
                            </div>
                        ) : (
                            successBlock
                        )
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    skuId: getFilteredSkuId(ownProps.fromMiniPDP)(state),
    deviceName: selectDeviceName(state),
    featureFlags: selectFeatureFlags(state),
    myAlerts: selectMyAlertsWrapper(ownProps.fromMiniPDP)(state),
    optinOrigin: get(selectPreferences(state), 'optinHeader.pdp', 'OPOP'),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            signupForAlerts,
            clearData,
            myAlertsLoader,
            ...orderActions,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyAlertsSignup);
